import { render, staticRenderFns } from "./procurementPlanDetail.vue?vue&type=template&id=276655f1&scoped=true"
import script from "./procurementPlanDetail.vue?vue&type=script&lang=js"
export * from "./procurementPlanDetail.vue?vue&type=script&lang=js"
import style0 from "./procurementPlanDetail.vue?vue&type=style&index=0&id=276655f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276655f1",
  null
  
)

export default component.exports